<template>
    <el-dropdown trigger="click" @command="handleAction" :placement="placement">
        <slot>
           <span :class="isHover ? 'move_icon' : ''" @mouseenter="mouseEnter" @mouseleave="mouseLeave" :style="{'background-color': isHover ? backgroundColor : ''}">
               <cl-svg-icon :iconClass="iconClass && !isEnter ? iconClass : 'more'" width="20"  :currentColor="false"></cl-svg-icon>
           </span>
        </slot>
        <el-dropdown-menu slot="dropdown">
            <slot name="other"></slot>
            <el-dropdown-item class="Disp_AC Major_Color br6" :command="item.value" :item="item" v-for="item in options" :key="item.value" :id="item.id">
                <cl-svg-icon :iconClass="item.class" class="mr8" :width="width" :height="height" :currentColor="!item.isColor" :style="item.svgStyle" :class="item.class"></cl-svg-icon>
                <span class="SysFontM">{{item['label'+$lang]}}</span>
            </el-dropdown-item>
            <slot name="otherBottom"></slot>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
    /**
     * ComponentName: 更多组件
     * Created Date:2022/4/21
     * Author: shishuo·zhang
     * Modify: Nancy 2022/4/26
     * 组件说明：
     * 点击icon显示更多，传入options，点击对应项通知父组件。
     * eg:
     *  <cl-more></cl-more>
     */
    export default {
        name: 'cl-more',
        props: {
            options: {
                default: () => ([{
                        label: '编辑',
                        labelEn: 'Edit',
                        value: 'edit',
                        class: 'edit',
                        // svgStyle: { color: 'red' }, // 单个svg的样式，非必传
                    },
                    {
                        label: '删除',
                        labelEn: 'Delete',
                        value: 'delete',
                        class: 'delete'
                    },
                ])
            },
            width: {
                type: String,
                default: '24'
            },
            height: {
                type: String,
                default: '24'
            },
            iconClass:{
                type: String,
                default: 'more'
            },
            placement: {
                type: String,
                default: 'bottom-end'
            },
            backgroundColor: {
                type: String,
                default: 'rgba(0,0,0,0.2)'
            },
            isHover:{
                type:Boolean,
                default:true
            },
        },
        data() {
            return {
                description: '下拉菜单',
                activeValue: this.options[0].value,
                activeIndex: '',
                isEnter:false,
            }
        },

        computed: {
            lang() {
                return this.$store.state.language === 'en'
            }
        },

        methods: {
            handleAction(option, Vnode) {
                this.activeValue = option
                this.$emit('click', option, Vnode.$attrs.item)
            },
            mouseEnter(){
                this.isEnter  = true ;
            },
            mouseLeave(){
                this.isEnter  = false ;
            },
        }

    }
</script>

<style lang="scss" scoped>
    .el-dropdown {
        .icon {
            margin: 0 auto;
        }
    }
    .move_icon{
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        box-sizing: border-box;
        &:hover{
            background-color:  #3663E1 !important;
            box-shadow: 0px 6px 8px rgba(54, 99, 225, 0.3);
        }
    }

    .el-dropdown-menu {
        padding: 8px;

        .el-dropdown-menu__item {
            padding: 5px 60px 5px 15px;

            &:hover {
                background: #F2F2F3;
                color: $base-font-major;
            }
        }
    }
</style>
